if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"limex-mf","remotes":[{"alias":"txAuthWidget","name":"txAuthWidget","entry":"https://libs-cdn.lime.co/auth-widget/mf/@8.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return false},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}